// Import Flowbite
import 'flowbite';

// Import Fontawesome
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
library.add(fas, far, fab);
dom.watch();

// Import AlpineJS
import Alpine from 'alpinejs'; 
import intersect from '@alpinejs/intersect';
Alpine.plugin(intersect);
window.Alpine = Alpine;
Alpine.start();

// Import component files
import './components/lightgallery.js';
import './components/flickity-sliders.js';
import './components/smoothscroll.js';

// Custom JavaScript can go here
document.addEventListener('DOMContentLoaded', () => {
  // Your initialization code


// END Your initialization code
});